export default "__VITE_ASSET__BUidb7HY__"